import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExpiryMethod } from 'client/voladeum/expiry-methods/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: ExpiryMethod[] = EMPTY_ARRAY;

export const expiryMethodsSlice = createSlice({
  name: SLICE.EXPIRY_METHODS,
  initialState,
  reducers: {
    setExpiryMethods: (_state, action: PayloadAction<ExpiryMethod[]>) => {
      return action.payload;
    },
    clearExpiryMethods: () => {
      return initialState;
    },
  },
});

export const { setExpiryMethods, clearExpiryMethods } = expiryMethodsSlice.actions;

export default expiryMethodsSlice.reducer;
